import FooterCommon from './FooterCommon.jsx';

export default function FooterFish() {
  return <FooterCommon />;
}
